import { calculateNewPrice } from '@dmf/calculator-library';
import { NewPriceCalcTaxDocType } from '../../../../types/taxTypes';

const calculate = (
  newPriceInput: NewPriceCalcTaxDocType,
) => {
  const { equipmentsPrice, newPriceWithoutEquipments, technicalNewPrice, useTechnicalNewPrice, useTaxableValueNewPrice } = newPriceInput || {};
  const newPrice = calculateNewPrice({
    equipmentPrice: equipmentsPrice || 0,
    newPrice: newPriceWithoutEquipments || 0,
    technicalNewPrice: technicalNewPrice || 0
  });

  if (useTaxableValueNewPrice && newPriceInput.taxableValueNewPrice) {
    return newPriceInput.taxableValueNewPrice
  }

  return useTechnicalNewPrice
    ? newPrice.technicalNewPrice
    : newPrice.totalSalesPrice;
}

export default calculate;
